import {fade} from "@khanacademy/wonder-blocks-tokens";

/**
 * Returns a function that fades a given color when the icon is disabled.
 *
 * Note: this essentially memoizes `fade()` but because the function args are
 * in reverse of the order we need (color is first), we have to "manually"
 * memoize it.
 */
export const faceIconColor = (disabled: boolean): ((arg1: string) => string) =>
    disabled ? (color: string) => fade(color, 0.32) : (color: string) => color;
